import { Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { CommonDataModel, ResponseFromServer } from '../../_models/models';
import { IHttpClient, HttpOptions } from '../http-client';
import { ServiceConfig } from '../service-config';
import { ResponseUnwrappingHttpClient } from './response-unwrapping-http-client';

export class FusionApiHttpClient extends ResponseUnwrappingHttpClient {
  constructor(
    httpClient: IHttpClient,
    serviceConfig: ServiceConfig
  ) {
    super(httpClient, serviceConfig.javaApiUrl);
  }

  getExpanded<TResponse>(relativePath: string, options?: HttpOptions): Observable<CommonDataModel<TResponse>> {
    return this.wrapInCommonDataModel(this.getRaw<TResponse>(relativePath, options));
  }

  postExpanded<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<CommonDataModel<TResponse>> {
    return this.wrapInCommonDataModel(this.postRaw<TResponse, TBody>(relativePath, body, options));
  }

  private wrapInCommonDataModel<TResponse>(
    source$: Observable<ResponseFromServer<TResponse>>
  ): Observable<CommonDataModel<TResponse>> {
    const commonDataModel = new CommonDataModel<TResponse>();
    commonDataModel.isLoading = true;
    commonDataModel.status = 'Fetching';

    return source$.pipe(
      map(resFromServer => {
        commonDataModel.data = resFromServer.data;
        commonDataModel.totalElements = resFromServer.totalElements ? resFromServer.totalElements : 0;
        commonDataModel.isLoading = false;
        commonDataModel.status = 'Success';
        return commonDataModel;
      }),
      startWith(commonDataModel),
      catchError(error => {
        commonDataModel.isLoading = false;
        commonDataModel.status = 'Failed';
        commonDataModel.httpErr = error;
        return of(commonDataModel);
      })
    );
  }
}
